function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './NavigationBar.css';
import React, { useState, useCallback } from 'react';
import TopNavigation from './TopNavigation';
import { get } from '../../utils/getPropertyByPath';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import MainNavigation from './MainNavigation';
import Breadcrumbs from '../30_NavigationBar/Breadcrumbs';
import LoginRegisterPopup from '../30_NavigationBar/LoginRegisterPopup';
import VenueShortlist from '../VenueShortlist/VenueShortlist';
import { NAV_LINKS, canUseDOM, isNavLinkRendered } from '../../utils';
import useProfile from '../../utils/hooks/useProfile';

/** Defines the props that are populated by data from CMS */

/** Defines the props that are populated by data from CMS and application usage */
// We can omit certain properties from some types because those properties are defined
// by the NavigationBar - the properties are not received from parent components.

const commonStyles = "cv2za98";
const ltrStyles = "l1maw8q2";
const rtlStyles = "rh6zdzy";
const NavigationBar = _ref => {
  let {
    topNav,
    mainNav,
    dictionary,
    accessibilitySettings,
    languageSelector,
    login,
    activeLanguage,
    breadcrumb,
    search,
    analytics,
    breadcrumbAnalytics,
    searchAnalytics
  } = _ref;
  const [state, setState] = useState({
    loginVisible: false,
    accessibilitySettingsVisible: false,
    searchVisible: false
  });
  const setHTMLScroll = React.useCallback(_ref2 => {
    let {
      disabled
    } = _ref2;
    if (typeof window === undefined) return;
    const html = document.querySelector('html');
    if (html) html.style.overflow = disabled ? 'hidden' : '';
  }, []);
  const toggleLoginVisibility = useCallback(() => {
    const newState = {
      languageSelectorVisible: false,
      accessibilitySettingsVisible: false,
      searchVisible: false,
      loginVisible: !state.loginVisible
    };
    setHTMLScroll({
      disabled: newState.loginVisible
    });
    if (!state.loginComponent) {
      import(/* webpackChunkName: "Login" */'../30_NavigationBar/Login').then(component => {
        newState.loginComponent = component.default;
        setState(newState);
      });
    } else {
      setState(newState);
    }
  }, [state.loginVisible, state.loginComponent, setHTMLScroll]);
  const toggleAccessibilitySettingsVisibility = useCallback(() => {
    const newState = {
      accessibilitySettingsVisible: !state.accessibilitySettingsVisible,
      languageSelectorVisible: false,
      searchVisible: false,
      loginVisible: false
    };
    setHTMLScroll({
      disabled: newState.accessibilitySettingsVisible
    });
    if (!state.accessibilitySettingsComponent) {
      import(/* webpackChunkName: "AccessibilitySettings" */'../30_NavigationBar/AccessibilitySettings').then(component => {
        newState.accessibilitySettingsComponent = component.default;
        setState(newState);
      });
    } else {
      setState(newState);
    }
  }, [state.accessibilitySettingsVisible, state.accessibilitySettingsComponent, setHTMLScroll]);
  const toggleSearchVisibility = useCallback(() => {
    const newState = {
      accessibilitySettingsVisible: false,
      languageSelectorVisible: false,
      searchVisible: !state.searchVisible,
      loginVisible: false
    };
    setHTMLScroll({
      disabled: newState.searchVisible
    });
    if (!state.searchComponent) {
      import(/* webpackChunkName: "SearchContainer" */'../30_NavigationBar/SearchContainer').then(component => {
        newState.searchComponent = component.default;
        setState(newState);
      });
    } else {
      setState(newState);
    }
  }, [state.searchVisible, state.searchComponent, setHTMLScroll]);
  const topNavActions = {
    onLoginClicked: toggleLoginVisibility,
    onAccessibilitySettingsClicked: toggleAccessibilitySettingsVisibility
  };
  const mainNavActions = {
    onLoginClicked: toggleLoginVisibility,
    onAccessibilitySettingsClicked: toggleAccessibilitySettingsVisibility,
    onSearchClicked: toggleSearchVisibility
  };
  const Login = state.loginComponent;
  const AccessibilitySettings = state.accessibilitySettingsComponent;
  const SearchContainer = state.searchComponent;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const userProfile = useProfile();
  const siteName = '';
  const [venueShortlistVisible, setVenueShortlistVisible] = React.useState(false);
  const menulinksArray = get(mainNav.menuLinks, 'targetItem.links');
  const primaryBrandLogo = get(mainNav, 'secondaryBrandLogo');
  const venueShortlists = menulinksArray && isNavLinkRendered(menulinksArray, NAV_LINKS['venuesShortlist']);
  // const idModifier = isAnimate ? 'nav-helper' : 'nav-main';
  const {
    removeVenueFromShortlistAnalytics,
    shareYourShortlistAnalytics,
    requestProposalAnalytics,
    yourShortlistedBottomAnalytics,
    yourShortlistedTopAnalytics,
    interactionWithVenueRPFormAnalytics
  } = mainNav;
  React.useEffect(() => {
    if (canUseDOM) {
      const header = document.querySelector('.dot-site-header');
      if (header) {
        header.classList.add('dot-site-header--fixed');
      }
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: `CORP NAVIGATION BAR ${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${siteName} ${pageEditing && onPageEditor}`
  }, /*#__PURE__*/React.createElement(LoginRegisterPopup, {
    dictionary: dictionary,
    accountLinks: mainNav.accountLinks
  }), /*#__PURE__*/React.createElement(LoginRegisterPopup, {
    dictionary: dictionary,
    accountLinks: mainNav.accountLinks,
    videoPopup: true
  }), /*#__PURE__*/React.createElement(TopNavigation, {
    accessibilitySettingsTitle: get(accessibilitySettings, 'targetItem.title.value'),
    globalLinks: topNav.globalLinks,
    actions: topNavActions,
    dictionary: dictionary
    // {...dictionary}
    ,

    accountLinks: mainNav.accountLinks,
    activeLanguageName: activeLanguage.languageName,
    languageSelectorTitle: get(languageSelector, 'targetItem.title.value'),
    analytics: {
      globalLinksAnalytics: analytics.globalLinksAnalytics,
      superNavAnalytics: analytics.superNavAnalytics
    }
  }), /*#__PURE__*/React.createElement(MainNavigation, _extends({}, mainNav, {
    userProfile: userProfile,
    dictionary: dictionary,
    globalLinks: topNav.globalLinks,
    actions: mainNavActions,
    mainMenuAnalytics: analytics.mainMenuAnalytics,
    globalLinksAnalytics: analytics.globalLinksAnalytics,
    governmentLogoAnalytics: analytics.governmentLogoAnalytics,
    removeVenueFromShortlistAnalytics: mainNav.removeVenueFromShortlistAnalytics,
    shareYourShortlistAnalytics: mainNav.shareYourShortlistAnalytics,
    requestProposalAnalytics: mainNav.requestProposalAnalytics,
    yourShortlistedBottomAnalytics: mainNav.yourShortlistedBottomAnalytics,
    yourShortlistedTopAnalytics: mainNav.yourShortlistedTopAnalytics,
    interactionWithVenueRPFormAnalytics: mainNav.interactionWithVenueRPFormAnalytics,
    languageSelector: languageSelector,
    isAnimate: true,
    venueShortlistVisible: venueShortlistVisible,
    setVenueShortlistVisible: setVenueShortlistVisible,
    venueShortlists: venueShortlists,
    activeLanguageName: activeLanguage.languageName
  })), /*#__PURE__*/React.createElement(Breadcrumbs, _extends({}, breadcrumb, {
    userProfile: userProfile,
    breadcrumbAnalytics: breadcrumbAnalytics
  })), Login ? /*#__PURE__*/React.createElement(Login, _extends({}, login, {
    onLoginClosed: toggleLoginVisibility,
    visible: state.loginVisible,
    analytics: analytics.superNavAnalytics
  })) : null, AccessibilitySettings ? /*#__PURE__*/React.createElement(AccessibilitySettings, _extends({}, accessibilitySettings, {
    onAccessibilitySettingsClosed: toggleAccessibilitySettingsVisibility,
    visible: state.accessibilitySettingsVisible,
    activeLanguageCode: activeLanguage.languageCode,
    analytics: {
      textSizeAnalytics: analytics.textSizeAnalytics,
      contrastSwitchAnalytics: analytics.contrastSwitchAnalytics,
      readSpeakerAnalytics: analytics.readSpeakerAnalytics
    }
  })) : null, SearchContainer ? /*#__PURE__*/React.createElement(SearchContainer, _extends({}, search, {
    onToggleSearch: toggleSearchVisibility,
    visible: state.searchVisible,
    analytics: searchAnalytics,
    primaryBrandLogo: primaryBrandLogo
  })) : null, !!venueShortlists && /*#__PURE__*/React.createElement(VenueShortlist, {
    fields: {
      dictionary: dictionary
    },
    params: {},
    isOpen: venueShortlistVisible,
    setOpen: setVenueShortlistVisible,
    analytics: {
      removeVenueFromShortlistAnalytics,
      shareYourShortlistAnalytics,
      requestProposalAnalytics,
      yourShortlistedBottomAnalytics,
      yourShortlistedTopAnalytics,
      interactionWithVenueRPFormAnalytics
    },
    formIdModifier: 'nav-helper'
  }));
};
const onPageEditor = "o17hcuxj";
export default NavigationBar;